import { render } from "./ClientProcessView.vue?vue&type=template&id=f621124e&scoped=true&ts=true"
import script from "./ClientProcessView.vue?vue&type=script&lang=ts"
export * from "./ClientProcessView.vue?vue&type=script&lang=ts"

import "./ClientProcessView.vue?vue&type=style&index=0&id=f621124e&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f621124e"]])

export default __exports__